import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Row = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 49px;

  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dotted ${colors.lightGray06};
`;
